var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from "js-cookie";
/**
 * sets cookie based on domain so it can be used cross app, vs on a single app
 * say.rocks vs app.say.rocks
 */
var getCookieAttributes = function () {
    if (window.location.hostname !== "localhost" &&
        window.location.hostname !== "127.0.0.1") {
        var domain = window.location.hostname.split(".").slice(-2).join(".");
        return {
            path: "/",
            domain: domain,
            sameSite: "none",
            secure: true,
        };
    }
    return {};
};
export var setCookie = function (_a) {
    var field = _a.field, value = _a.value, _b = _a.attributes, attributes = _b === void 0 ? {} : _b;
    Cookies.set(field, value, __assign(__assign({}, getCookieAttributes()), attributes));
};
export var getCookie = function (field) {
    return Cookies.get(field);
};
export var removeCookie = function (field) {
    Cookies.remove(field);
    Cookies.remove(field, getCookieAttributes());
};
export var setAuthToken = function (props) {
    return setCookie(__assign({ field: "authToken" }, props));
};
export var getAuthToken = function () { return getCookie("authToken"); };
export var removeAuthToken = function () { return removeCookie("authToken"); };
// For issuer portal due to conflict with iframes in app.say
export var setIssuerAuthToken = function (props) {
    return setCookie(__assign({ field: "issuerAuthToken" }, props));
};
export var getIssuerAuthToken = function () {
    return getCookie("issuerAuthToken");
};
export var removeIssuerAuthToken = function () {
    return removeCookie("issuerAuthToken");
};
